import Alpine from "alpinejs";

export default function () {
    document.addEventListener('alpine:init', () => {
        Alpine.data('MotocampRegistrationForm', () => {
            const pricing = {
                turnus: {
                    organizovane: 52000,
                    skupinove: 55000,
                    pronajem: 0,
                },
                spolujezdec: 30000,
                klient: -6000,
                motoskola: 6500,
                doprava: -7000,
                ubytovani: {
                    zaklad: 5000,
                    skupinove: 6000,
                },
            }

            return {
                step: 1,
                ponekolikate: undefined,
                typ: undefined,
                turnus: '',
                klient: undefined,
                motoskola: undefined,
                doprava: undefined,
                letiste: undefined,
                ubytovani: undefined,
                spolubydlici: undefined,
                stejnaAdresa: false,

                tryGoingToNextStep() {
                    let valid = true;
                    let invalidInput = null;

                    const inputs = this.$el.closest('form').querySelectorAll('fieldset.AppForm-inner > div.FormSection:not([data-last-step]) :where(input, select)');
                    Array.from(inputs).forEach((input: HTMLInputElement) => {
                        if (invalidInput || input.checkValidity()) return;

                        valid = false;
                        invalidInput = input;
                    });

                    (valid && !invalidInput) ? ((this.step = 2) && document.querySelector('h1').scrollIntoView()) : invalidInput.reportValidity();
                },

                init() {
                    this.$watch('ponekolikate', () => !['1','11','12','3','6'].includes(this.turnus) && (this.turnus = ''))
                    this.$watch('motoskola', () => this.motoskola === 'ano' && (this.doprava = 'ne'))
                },

                get isTurnusTulaci() {
                    return ['2','4','7'].includes(this.turnus)
                },

                get isRnR() {
                    return ['5'].includes(this.turnus)
                },

                get getTurnusName() {
                    switch (this.turnus) {
                        case '1': return '16.1. - 20.1.2027 | Organizovaná vyjížďka s guidy';
                        case '11': return '16.1. - 20.1.2027 | Organizovaná vyjížďka s guidy - DÁMSKÁ JÍZDA';
                        case '12': return '16.1. - 20.1.2027 | Organizovaná vyjížďka s guidy - BEZKOLÍNKA';
                        case '3': return '23.1. - 27.1.2027 | Organizovaná výjižďka s guidy';
                        case '6': return '6.2. - 10.2.2027 | Organizovaná výjižďka s guidy';
                        case '2': return '16.1. - 21.1.2027 | Organizovaná výjižďka s guidy - skupina TULÁCI';
                        case '4': return '23.1. - 28.1.2027 | Organizovaná výjižďka s guidy - skupina TULÁCI';
                        case '7': return '6.2. - 11.2.2027 | Organizovaná výjižďka s guidy - skupina TULÁCI';
                        case '5': return '29.1.- 5.2.2027 | RENT and RIDE – délka trvání dle tvé volby';
                    }
                },

                get price() {
                    let price = 0;

                    if (this.turnus !== '' && this.typ === 'řidič') {
                        if (['1','11', '12','3','6'].includes(this.turnus)) {
                            price += pricing.turnus.organizovane;

                            if (this.klient === 'ano' || this.ponekolikate === 'ano') {
                                price += pricing.klient;
                            }
                        } else if (['2','4','7'].includes(this.turnus)) {
                            price += pricing.turnus.skupinove;
                        } else if (['5'].includes(this.turnus)) {
                            price += pricing.turnus.pronajem;
                        }
                    } else if (this.typ === 'spolujezdec') {
                        price = pricing.spolujezdec;
                    }

                    if (this.motoskola === 'ano') {
                        price += pricing.motoskola;
                    }

                    if (this.doprava === 'ne') {
                        price += pricing.doprava;
                    }

                    if (this.ubytovani === 'samostatne') {
                        price += this.isTurnusTulaci ? pricing.ubytovani.skupinove : pricing.ubytovani.zaklad;
                    }

                    return Math.max(0, price);
                },
            }
        });
    });

    document.addEventListener("DOMContentLoaded", () => {
        window.hasOwnProperty('html_forms') && html_forms?.on('success', (formElement: HTMLFormElement) => {
            if (!formElement || formElement.dataset.slug !== 'motocamp-registration') return;
            document.querySelector('section.PageHeader').scrollIntoView();
        });
    });
}